import { render } from "./teamShare.vue?vue&type=template&id=0f5849a6&scoped=true"
import script from "./teamShare.vue?vue&type=script&lang=js"
export * from "./teamShare.vue?vue&type=script&lang=js"

import "./teamShare.vue?vue&type=style&index=0&id=0f5849a6&scoped=true&lang=less"

import exportComponent from "/root/drive/src/landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f5849a6"]])

export default __exports__